import React, { useState } from "react";
import ReactDOM from "react-dom";
import UserService from "../../services/user/user.service";
import AuthService from "../../services/auth/auth.service";
import {
  useSearchParams
} from "react-router-dom"
import {decode as base64_decode, encode as base64_encode} from 'base-64';



const ChangePassword = () => {
  const [errorMessages, setErrorMessages] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);

  const [queryParameters] = useSearchParams()

  var username = queryParameters.get("username")

  var user = AuthService.getCurrentUser()
  var dispoldpass=""
  var setpasswd = false;
  if (username){
    dispoldpass="none"
    setpasswd=true
    if (user.group>2){
       AuthService.logout();
       window.location.href = '/' 
    }

  }

 


  const handleSubmit = (event) => {
    //Prevent page reload
    event.preventDefault();
    var { oldpass, newpass, confirmpass } = document.forms[0];

    if (setpasswd){
      UserService.setpassword(username,newpass.value, confirmpass.value).then(
        () => { 
          setErrorMessages({message:'Hasło zostało zmienione!'});
        }
      
      ).catch(
        function (error) {
          console.log("AAAAAAAA")
          //console.log(error)
          console.log(error);
          setErrorMessages({message:'Błąd przy zmianie hasła!'});
          try{
            if (error.response.data.detail){
              setErrorMessages({message:error.response.data.detail});
            }
          }catch{

          }
        }
      ); 
    }else{
      UserService.changepassword(oldpass.value,newpass.value, confirmpass.value).then(
        () => { 
        setErrorMessages({message:'Hasło zostało zmienione!'});
        }
      
      ).catch(
        function (error) {
          console.log("AAAAAAAA")
          //console.log(error)
          console.log(error);
          setErrorMessages({message:'Błąd przy zmianie hasła!'});
          try{
            if (error.response.data.detail){
              setErrorMessages({message:error.response.data.detail});
            }
          }catch{

          }
        }
      ); 
    } 
   
  };

  const renderErrorMessage = () =>
    (
      <p style={{color:'#FF0000'}} className="login-box-msg">{errorMessages.message}</p>

    );

  const renderForm = (
          <div className="card-body">
            <form onSubmit={handleSubmit} method="post">
            
              <div style={{display:dispoldpass}} className="input-group mb-3">
                <input name="oldpass" type="password" className="form-control" placeholder="Stare hasło" />
                <div className="input-group-append">
                  <div className="input-group-text">
                    <span className="fas fa-lock" />
                  </div>
                </div>
              </div>
              <div className="input-group mb-3">
                <input name="newpass"  type="password" className="form-control" placeholder="Nowe hasło" />
                <div className="input-group-append">
                  <div className="input-group-text">
                    <span className="fas fa-lock" />
                  </div>
                </div>
              </div>
              <div className="input-group mb-3">
                <input name="confirmpass"  type="password" className="form-control" placeholder="Potwierdź hasło" />
                <div className="input-group-append">
                  <div className="input-group-text">
                    <span className="fas fa-lock" />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <button type="submit" className="btn btn-primary btn-block">Zmień hasło</button>
                </div>
                {/* /.col */}
              </div>
            </form>
            <span style={{float:"left"}} className="mt-3 mb-2">
              <a href="/login">Zaloguj</a>
            </span>
            <span style={{float:"right"}} className="mt-3 mb-2">
              <a href="/">Powrót</a>
            </span>
          </div>
  );
  
    return (
      <div className="login-box">
        <div className="card card-outline card-primary">
          <div className="card-header text-center">
            <a href="/changepassword" className="h1"><b>CRM</b>ExpoProperty</a>
          </div>     
          {errorMessages.message ? renderErrorMessage() : <> <p className="login-box-msg">Zmiana hasła{username?" użytkownika: " : ""}</p><p className="login-box-msg">{username}</p></>}
          {isSubmitted ? <div>Poprawnie zmieniono hasło</div> : renderForm}
        </div>
      </div>


    )
  }
  
  export default ChangePassword;